import { createContext, useContext, useState } from "react"

const TabsContext = createContext(null)

function useTabsContext() {
    const context = useContext(TabsContext)
    if (!context) {
        throw new Error("Tabs components must be used within <Tabs>")
    }
    return context
}

export function Tabs({
    defaultValue,
    value: controlledValue,
    onValueChange,
    className = "",
    children,
}) {
    const isControlled = controlledValue !== undefined
    const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue)
    const value = isControlled ? controlledValue : uncontrolledValue

    const handleChange = (next) => {
        if (!isControlled) {
            setUncontrolledValue(next)
        }
        onValueChange?.(next)
    }

    return (
        <TabsContext.Provider value={{ value, onChange: handleChange }}>
            <div className={["aurora-tabs", className].filter(Boolean).join(" ")}>{children}</div>
        </TabsContext.Provider>
    )
}

export function TabsList({ className = "", children, ...props }) {
    return (
        <div
            role="tablist"
            className={["aurora-tabs__list", className].filter(Boolean).join(" ")}
            {...props}
        >
            {children}
        </div>
    )
}

export function TabsTrigger({ value, className = "", children, ...props }) {
    const { value: activeValue, onChange } = useTabsContext()
    const isActive = activeValue === value

    return (
        <button
            type="button"
            role="tab"
            aria-selected={isActive}
            data-active={isActive}
            className={["aurora-tabs__trigger", className].filter(Boolean).join(" ")}
            onClick={() => onChange(value)}
            {...props}
        >
            {children}
        </button>
    )
}

export function TabsContent({ value, className = "", children, ...props }) {
    const { value: activeValue } = useTabsContext()
    const isActive = activeValue === value
    if (!isActive) return null

    return (
        <div
            role="tabpanel"
            className={["aurora-tabs__content", className].filter(Boolean).join(" ")}
            {...props}
        >
            {children}
        </div>
    )
}

export default Tabs




